import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { PaymentsListWrapper } from './payments-list/PaymentsList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const paymentsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Payment Management',
    path: '/admin/pages/payments',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/payments/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const PaymentsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='payments'
          index
          element={
            <>
              <PageTitle breadcrumbs={paymentsBreadcrumbs}>Payments list</PageTitle>
              <PaymentsListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/payments/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/payments' />} />
    </Routes>
  )
}

export default PaymentsPage
